import styled from 'styled-components';

export const RadioWrapper = styled.div`
  margin-bottom: 4px;

  &:last-child {
    margin-bottom: 24px;
  }
`;
